import { getStrapiMedia } from '../../lib/blog/media'
import NextImage from 'next/legacy/image'

const BlogImage = ({ image }) => {
  const {
    alternativeText,
    width,
    height
  } = image.data.attributes

  const myLoader = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`
  }

  return (
    // <img
    //   src={getStrapiMedia(image)}
    // />
    <NextImage
      loader={myLoader}
      layout="responsive"
      width={width}
      height={height}
      objectFit="cover"
      src={getStrapiMedia(image)}
      alt={alternativeText || ''}
    />
  )
}

export default BlogImage
